/**
 * Documentation DOCHAZKA API
 * ## Common Request Headers - Authorization (string `Bearer {AccessToken}`, if signed-in) - After the client has successfully obtained `AccessToken` via Login, it\'s sent in every request as a bearer token.
 *
 * The version of the OpenAPI document: 1
 * Contact: novak@techcrowd.cz
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface RegisterUserRequest { 
    /**
     * First name
     */
    firstname: string;
    /**
     * Last name
     */
    lastname: string;
    /**
     * Email
     */
    email: string;
    /**
     * Phone
     */
    phone?: string;
    /**
     * password
     */
    password: string;
    /**
     * Confirmation password
     */
    passwordConfirmation: string;
    companyName: string;
    alias?: string;
    invoiceStreet?: string;
    invoiceCity?: string;
    invoiceCountry?: string;
    invoiceZip?: string;
    vatNumber?: string;
    idNumber?: string;
}

